import { collection, doc, getDocs, getFirestore, query, serverTimestamp, setDoc, where } from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";

const db = getFirestore(firebaseApp);

const cleanText = (v) => (v == null ? "" : String(v).trim());

export const EVENTOS_SIRE_AUDITORIA = Object.freeze({
  PROPUESTA_DESCARGADA: "PROPUESTA_DESCARGADA",
  CONCILIACION_INICIADA: "CONCILIACION_INICIADA",
  CONCILIADO: "CONCILIADO",
  CON_DIFERENCIAS: "CON_DIFERENCIAS",
  ARCHIVO_GENERADO: "ARCHIVO_GENERADO",
  PRESENTACION_INICIADA: "PRESENTACION_INICIADA",
  TICKET_RECIBIDO: "TICKET_RECIBIDO",
  PRESENTACION_ACEPTADA: "PRESENTACION_ACEPTADA",
  PRESENTACION_OBSERVADA: "PRESENTACION_OBSERVADA",
  PRESENTACION_RECHAZADA: "PRESENTACION_RECHAZADA",
  PERIODO_CERRADO: "PERIODO_CERRADO",
  PERIODO_REABIERTO: "PERIODO_REABIERTO",
});

export const registrarEventoAuditoriaSire = async ({
  rucEmpresa,
  periodo,
  tipo,
  evento,
  usuario,
  metadata = {},
}) => {
  const cleanRuc = cleanText(rucEmpresa);
  const cleanPer = cleanText(periodo);
  const cleanTip = cleanText(tipo).toUpperCase();
  const cleanEvt = cleanText(evento);

  const timestampId = Date.now().toString();
  const docId = `${cleanRuc}_${cleanPer}_${cleanTip}_${cleanEvt}_${timestampId}`;
  const docRef = doc(db, CONT_COLLECTIONS.SIRE_AUDITORIA, docId);

  const payload = {
    ruc_empresa: cleanRuc,
    periodo: cleanPer,
    tipo: cleanTip,
    evento: cleanEvt,
    usuario: cleanText(usuario),
    fecha: serverTimestamp(),
    metadata: {
      ...metadata,
      ip: cleanText(metadata.ip || "127.0.0.1"),
      user_agent: cleanText(metadata.user_agent || "MiBoletaApp/v2"),
    },
  };

  await setDoc(docRef, payload);
  return { id: docId, ...payload };
};

export const obtenerAuditoriaSire = async ({ rucEmpresa, periodo, tipo }) => {
  const cleanRuc = cleanText(rucEmpresa);
  const cleanPer = cleanText(periodo);
  const cleanTip = cleanText(tipo).toUpperCase();

  const q = query(
    collection(db, CONT_COLLECTIONS.SIRE_AUDITORIA),
    where("ruc_empresa", "==", cleanRuc),
    where("periodo", "==", cleanPer),
    where("tipo", "==", cleanTip)
  );

  const snap = await getDocs(q);
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort((a, b) => String(b.id).localeCompare(String(a.id)));
};
